module.exports = __webpack_public_path__ + "static/media/black.ac3f5ba3.svg";